export default "__VITE_ASSET__b5f4edc6__"